import React, { useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { Form, Button } from "react-bootstrap";
import { Controller } from "react-hook-form";

function Phone_Number_SignUp({ control, register, errors, watch }) {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  return (
    <>
      {/* Phone Number */}
      <div className="form-group field_holder">
        <Form.Label>
          <img
            src="/assets/images/icons/phone.png"
            alt="icon"
            className="login_lable_icons"
          />{" "}
          Phone number
        </Form.Label>

        <Form.Control
          placeholder="Phone number"
          type="text"
          name="contact_no"
          maxLength={10} // restrict typing to 10 digits
          {...register("contact_no", {
            required: "Phone number is required",
            pattern: {
              value: /^[0-9]+$/,  // only numbers
              message: "Only digits are allowed",
            },
            minLength: {
              value: 10,
              message: "Phone number must be exactly 10 digits",
            },
            maxLength: {
              value: 10,
              message: "Phone number must be exactly 10 digits",
            },
          })}
        />
        {errors.contact_no && (
          <small className="text-danger">{errors.contact_no.message}</small>
        )}
      </div>

      {/* Set Password */}
      <div className="form-group field_holder">
        <Form.Label>
          <img
            src="/assets/images/icons/lock.png"
            alt="icon"
            className="login_lable_icons"
          />{" "}
          Set Password
        </Form.Label>
        <div className="password_input">
          <Form.Control
            type={showPassword ? "text" : "password"}
            placeholder="Set Password"
            {...register("password", {
              required: "Password is required",
              minLength: {
                value: 6,
                message: "Password must be at least 6 characters",
              },
            })}
          />
          <span
            className="eye-icon"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? <FaEye /> : <FaEyeSlash />}
          </span>
        </div>
        {errors.password && (
          <small className="text-danger">{errors.password.message}</small>
        )}
      </div>

      {/* Confirm Password */}
      <div className="form-group field_holder">
        <Form.Label>
          <img
            src="/assets/images/icons/lock.png"
            alt="icon"
            className="login_lable_icons"
          />{" "}
          Confirm Password
        </Form.Label>
        <div className="password_input">
          <Form.Control
            type={showConfirmPassword ? "text" : "password"}
            placeholder="Confirm Password"
            {...register("confirm_password", {
              required: "Please confirm your password",
              validate: (value) =>
                value === watch("password") || "Passwords do not match",
            })}
          />
          <span
            className="eye-icon"
            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
          >
            {showConfirmPassword ? <FaEye /> : <FaEyeSlash />}
          </span>
        </div>
        {errors.confirm_password && (
          <small className="text-danger">{errors.confirm_password.message}</small>
        )}
      </div>

      {/* Invite Code */}
      <div className="form-group field_holder invite_code_wrapper">
        <Form.Label>
          <img
            src="/assets/images/icons/sheild.png"
            alt="icon"
            className="login_lable_icons"
          />{" "}
          Invite Code
        </Form.Label>
        <div className="invite_input">
          <Form.Control
            type="text"
            placeholder="Please Enter the Invitation Code"
            {...register("refer_code", {
              required: "Invite Code is required",
            })}
          />

          {errors.refer_code && (
            <small className="text-danger">{errors.refer_code.message}</small>
          )}
        </div>
      </div>
    </>
  );
}

export default Phone_Number_SignUp;